import { createStore, combineReducers, applyMiddleware, compose } from 'redux';

import thunk from 'redux-thunk';

import { routerMiddleware, push } from 'react-router-redux';

import { googleAnalytics } from './reactGaMiddleware'

import reducers from '../reducers';
import history from './history';

function reduxStore(initialState) {

  // Build the middleware for intercepting and dispatching navigation actions
  const router_middleware = routerMiddleware(history);

  const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  const enhancer = composeEnhancers(
    applyMiddleware(...router_middleware),
    applyMiddleware(thunk),
    applyMiddleware(googleAnalytics)
    // other store enhancers if any
  );

  const store = createStore(
    reducers, 
    initialState,
    enhancer
  );

  if (module.hot) {
    // Enable Webpack hot module replacement for reducers
    module.hot.accept('../reducers', () => {
      // We need to require for hot reloading to work properly.
      const nextReducer = require('../reducers');  // eslint-disable-line global-require

      store.replaceReducer(nextReducer);
    });
  }

  return store;
}

export default reduxStore();



// WEBPACK FOOTER //
// ./stores/index.js